import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Button from '../../Button';
import { IconTrash } from '../../Icons';
import InputRadio from '../../InputRadio';
import SessionsDetailModalSectionTitle from './SessionsDetailModalSectionTitle';
import Spinner from '../../Spinner';

const SessionsDetailModalDeleteSettings = ({
  expires,
  loading,
  onExpireToggled,
  onDeleteMessages,
  onDeleteChat,
  ...props
}) => {
  const { t } = useTranslation('components');

  const toggle = event => {
    onExpireToggled(event);
  };

  return (
    <section data-component="SessionsDetailModalDeleteSettings" {...props}>
      <form className="flex flex-col mt-6">
        <SessionsDetailModalSectionTitle>
          {t('Sessions.SessionsDetailModal.SessionsDetailDeleteSettings.subTitle')}
          {loading && <Spinner size="xs" className="ml-2" />}
        </SessionsDetailModalSectionTitle>
        <div className="flex flex-col">
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label className="flex items-center mb-2">
            <InputRadio
              name="expires"
              value="false"
              className="w-4 h-4"
              checked={!expires}
              onChange={toggle}
            />
            <span className="ml-2">
              {t('Sessions.SessionsDetailModal.SessionsDetailDeleteSettings.options.noDeletion', {
                allowHtml: true,
              })}
            </span>
          </label>

          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label className="flex items-center mb-2">
            <InputRadio
              name="expires"
              value="false"
              className="w-4 h-4"
              checked={expires}
              onChange={toggle}
            />
            <span className="ml-2">
              {t('Sessions.SessionsDetailModal.SessionsDetailDeleteSettings.options.deletion')}
            </span>
          </label>
        </div>
      </form>
      <Button kind="link" className="mt-2" onClick={onDeleteMessages}>
        <IconTrash size="text" />
        <span className="ml-2">
          {t('Sessions.SessionsDetailModal.SessionsDetailDeleteSettings.deleteChatContents')}
        </span>
      </Button>
      <SessionsDetailModalSectionTitle className="mt-6">
        {t('Sessions.SessionsDetailModal.SessionsDetailDeleteSettings.delete_chat.title')}
      </SessionsDetailModalSectionTitle>
      <div className="text-slate-600">
        {t('Sessions.SessionsDetailModal.SessionsDetailDeleteSettings.delete_chat.info')}
      </div>
      <Button className="mt-4" onClick={onDeleteChat}>
        {t('Sessions.SessionsDetailModal.SessionsDetailDeleteSettings.delete_chat.button')}
      </Button>
    </section>
  );
};

SessionsDetailModalDeleteSettings.propTypes = {
  expires: PropTypes.bool,
  onExpireToggled: PropTypes.func,
  onDeleteMessages: PropTypes.func,
  onDeleteChat: PropTypes.func,
  loading: PropTypes.bool,
};

SessionsDetailModalDeleteSettings.defaultProps = {
  expires: false,
  loading: false,
  onExpireToggled: () => {},
  onDeleteMessages: () => {},
  onDeleteChat: () => {},
};

export default SessionsDetailModalDeleteSettings;
